// Google OAuth configuration
export const googleClientId = "817800310507-4bvn6jnon6qdhnkndfk5d5v8e5ntr78j.apps.googleusercontent.com";

// Load Google Identity Services
export const loadGoogleScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[src="https://accounts.google.com/gsi/client"]')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Identity Services'));
    document.head.appendChild(script);
  });
};

export const initializeGoogleSignIn = (callback: (response: any) => void) => {
  (window as any).google.accounts.id.initialize({
    client_id: googleClientId,
    callback: callback,
    auto_select: false,
  });
};

export const renderGoogleButton = (elementId: string) => {
  (window as any).google.accounts.id.renderButton(
    document.getElementById(elementId),
    { theme: 'outline', size: 'large', width: '100%' }
  );
};
